import kaplay from "kaplay";
import { loadAllAssets } from "./assets.js";
import { tiledPlugin } from 'kaplay-plugin-tiled';

// 1. 初始化 Kaplay
const k = kaplay({
    focus: false,
    font: "happy",
    background: "#717FF2",
    scale: 1,
    pixelDensity: Math.min(devicePixelRatio, 2),
    plugins: [tiledPlugin],
});

// 2. 立即显示加载提示（覆盖全屏，z-index 最高）
const loadingText = add([
    text("⏳ 正在加载资源...", { size: 32, font: "base_font" }),
    pos(center().x, center().y - 20),
    anchor("center"),
    color(255, 255, 255),
    z(999),
]);

const spinner = add([
    circle(16),
    pos(center().x, center().y + 30),
    color(255, 215, 0),
    z(999),
]);
spinner.onUpdate(() => { spinner.angle += 0.08; }); // 旋转动画

// 3. 异步引导启动（保证资源加载完成后再进入菜单）
(async function boot() {
    // 加载所有资源（图片、字体等）
    await loadAllAssets();   // 假设 loadAllAssets 返回 Promise

    // 动态导入所有场景（会触发代码加载，通常较快）
    await import("./scenes/menu.js");
    await import("./scenes/mine.js");
    await import("./scenes/wordbook.js");
    await import("./scenes/wordlist.js");
    await import("./scenes/playmode.js");
    await import("./scenes/play1.js");
    await import("./scenes/play2.js");
    await import("./scenes/multiplay.js");
    await import("./scenes/flashcards.js");
    await import("./scenes/classes.js");
    await import("./scenes/rank.js");
    await import("./scenes/share.js");
    // await import("./scenes/world.js");
    // await import("./scenes/game-scenes/login.js");
    // await import("./scenes/game-scenes/myhouse.js");
    // await import("./scenes/game-scenes/study.js");
    await import("./utils/utils.js");

    // 移除加载提示
    loadingText.destroy();
    spinner.destroy();

    // 启动菜单场景
    go("menu");
})();